import { createRoute } from '@tanstack/react-router'
import { Route as appLayoutRoute } from '../layout'

export const Route = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/accounting/entries/new',
}).lazy(() => import('./entries.new.lazy').then((d) => d.Route))
